import { ReserveDataHumanized } from '@yldr/contract-helpers';

export interface TransactionHistoryParams {
  account: string;
  endpointURL: string;
}

export enum EOperationType {
  Supply = 'supply',
  Withdraw = 'withdraw',
  Borrow = 'borrow',
  Repay = 'repay',
  SupplyErc1155 = 'supply_erc1155',
  WithdrawErc1155 = 'withdraw_erc1155',
  Leverage = 'leverage',
  Deleverage = 'deleverage',
  Rebalance = 'rebalance',
  Compound = 'compound',
  CreateAndLeverage = 'create_and_leverage',
  LeverageLiquidate = 'leverage_liquidate',
  ClosePosition = 'close_position',
  ClaimFees = 'claim_fees',
}

export interface ITransactionHistoryItemResponse {
  amount: number | null;
  amount_0: number | null;
  amount_1: number | null;
  chain_id: number;
  erc1155_token_address: string | null;
  erc1155_token_id: number | null;
  operation_type: EOperationType;
  timestamp: number;
  token_address: string | null;
  transaction_hash: string;
  user_address: string;
}

export interface ITransactionHistoryItem {
  amount: number;
  amount0: number;
  amount1: number;
  chainId: number;
  erc1155TokenAddress: string | null;
  erc1155TokenId: number | null;
  operationType: EOperationType;
  timestamp: number;
  tokenAddress: string | null;
  transactionHash: string;
  userAddress: string;
  reserve: ReserveDataHumanized;
}

export interface HistoryFilters {
  searchQuery?: string;
  filterQuery: EOperationType[];
}
